const filters = document.querySelectorAll(".origin-filter");
const filteredText = document.querySelectorAll(".filtered-text");

export default function init() {
  filters.forEach( (filter, index, allFilters)=> {
    filter.addEventListener("click", () => {
      deactivate(allFilters);
      filters[index].classList.add("active");
      filteredText[index].classList.add("active");
    });
  })
  
  function deactivate(allFilters){
    for (let i = 0 ; i < allFilters.length ; i++) {
      filters[i].classList.remove('active');
      filteredText[i].classList.remove("active");
    }
  }

  function hideAndShow() {
    // remove and display 
  }
}
